
export const LinkEvitement = () => {
  return (
    <nav id="skip-link">
        <a href="#navigation" className="evitement">Aller vers la naviagtion</a>
        <a href="#contenu" className="evitement">Aller vers le contenu</a>
    </nav>
  )
}


